import { useMemo } from "react";
import { useViewModeState } from "./useViewModeState";

/**
 * Composition hook for View Mode State
 * Manages the current view mode (table, grouped, or cards)
 *
 * Job Duty: Manage view mode state
 */
export function useCompositionViewMode(entityName: string) {
  const { viewMode, setViewMode } = useViewModeState(entityName);

  return useMemo(
    () => ({
      viewMode,
      setViewMode,
    }),
    [viewMode, setViewMode]
  );
}
